export const fontFamily = {
  main: `'Roboto', 'Helvetica', 'Arial', sans-serif`,
  code: 'Monospace',
  lyrics: `'Gilroy', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
  bamOnline: `'Circular Std', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
};

export interface Mp3KbpPlayerCommonColors {
  timerCircularProgress: string;
  timerCircularProgressBackground: string;
}
